import { Suspense, lazy } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute, useAuth } from '../../../../shared/ui';
import { UserRole } from '../../../../shared/utils/types';
import { NotFoundPage } from '../../pages/NotFoundPage';

const AdminDashboard = lazy(() =>
  import('../../pages/admin/AdminDashboard').then(m => ({
    default: m.AdminDashboard,
  }))
);

const ProtectedAdminDashboard = () => {
  const { user } = useAuth();
  if (user?.role !== UserRole.ADMIN) return <NotFoundPage />;
  return (
    <ProtectedRoute>
      <Suspense fallback={<div>Loading...</div>}>
        <AdminDashboard />
      </Suspense>
    </ProtectedRoute>
  );
};

export const Route = createFileRoute('/admin/')({
  component: ProtectedAdminDashboard,
});
